import { styled, css } from 'styled-components';
import { Link as RouterLink } from '@/js/libs/router';
export const linkStyles = css `
  text-decoration: none;
  cursor: pointer;
  transition: color 150ms ease;

  &,
  &:visited {
    color: ${({ theme }) => theme.colors.link100};
  }

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.link120};
    text-decoration: none;
  }
`;
const Link = styled(RouterLink) `
  ${linkStyles}
`;
export const LinkSpan = styled.span `
  ${linkStyles}
`;
// An anchor that opens in a new tab: a third-party url, or a console page meant to stand beside
// the one being read. `attrs` wins over incoming props in styled-components, so `noopener
// noreferrer` holds at every call site and no site can weaken it.
export const ExternalLink = styled.a.attrs({ target: '_blank', rel: 'noopener noreferrer' }) `
  ${linkStyles}
`;
export default Link;
